import { designTokens } from "@itandi/itandi-bb-ui";
import { Alertv2 } from "@itandi/itandi-bb-ui/Alertv2";
import { Buttonv2 } from "@itandi/itandi-bb-ui/Buttonv2";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import { formatDate } from "@itandi/tools/vanilla";
import { useState } from "react";
import useSWRMutation from "swr/mutation";
import { useDealContext } from "~/context/DealContext";
import { dealCacheKey } from "~/hooks/useDeals";
import { isSuccess } from "~/utils/api/api_handler";
import { update } from "~/utils/api/deals/RevertOwnStatus";
import Styles from "./statuses.module.scss";

export function OwnFinished() {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const deal = useDealContext();
	const { notify } = useNotification();

	const { trigger, isMutating } = useSWRMutation(
		dealCacheKey(deal.id),
		async () => update(deal.id)
	);

	const onClickRevertButton = async () => {
		const result = await trigger();
		if (isSuccess(result)) {
			notify({ content: "ステータスを戻しました。", variant: "success" });
			setIsModalOpen(false);
		} else {
			notify({
				content: `エラーが発生しました。${result.message ?? ""}`,
				variant: "error"
			});
		}
	};

	return (
		<div>
			<h3 className={Styles.Title}>完了しました</h3>
			<p className={Styles.Description}>すべての工事工程が完了しました</p>
			<Flex justifyContent="end">
				<Buttonv2
					color="danger"
					onClick={() => {
						setIsModalOpen(true);
					}}
					variant="secondary"
				>
					ステータスを戻す
				</Buttonv2>
			</Flex>
			{isModalOpen ? (
				<Modalv2
					isOpen
					onClose={() => {
						setIsModalOpen(false);
					}}
					size="s"
				>
					<ModalHeader title="完了した案件のステータスを戻す" />
					<ModalBody>
						<Paragraph>ステータスを戻します。</Paragraph>
						<Alertv2 mt={designTokens["spacing/m"]} variant="warning">
							<Paragraph>
								完了日（{formatDate(deal.completedDate)}）がクリアされます。
							</Paragraph>
						</Alertv2>
					</ModalBody>
					<ModalFooter
						leftArea={
							<Buttonv2
								disabled={isMutating}
								onClick={() => {
									setIsModalOpen(false);
								}}
								variant="secondary"
							>
								キャンセル
							</Buttonv2>
						}
						rightArea={
							<Buttonv2
								loading={isMutating}
								onClick={onClickRevertButton}
								variant="primary"
							>
								確定
							</Buttonv2>
						}
					/>
				</Modalv2>
			) : null}
		</div>
	);
}
